import { colors } from 'styles/theme/colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export default function InfoIconThinOutline({ size = 15, ...rest }: Props) {
  return (
    <svg width={size} height={size} viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M7.5 14.5C11.366 14.5 14.5 11.366 14.5 7.5C14.5 3.63401 11.366 0.5 7.5 0.5C3.63401 0.5 0.5 3.63401 0.5 7.5C0.5 11.366 3.63401 14.5 7.5 14.5Z'
        stroke='#021320'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path d='M7.5 6.86371V10.6819' stroke={colors.black} strokeMiterlimit='10' strokeLinecap='square' />
      <path
        d='M7.50013 4.95449C7.85159 4.95449 8.1365 4.66958 8.1365 4.31813C8.1365 3.96667 7.85159 3.68176 7.50013 3.68176C7.14868 3.68176 6.86377 3.96667 6.86377 4.31813C6.86377 4.66958 7.14868 4.95449 7.50013 4.95449Z'
        fill='#021320'
      />
    </svg>
  );
}
